<div class="floating-container">
  <!-- Draggable Window -->
  <div class="uploader-window" [class.hidden]="!isWindowVisible" [class.minimized-pos]="isMinimized"
    [class.centered-window]="isCentered" cdkDrag cdkDragBoundary="body">
    <div class="header" cdkDragHandle>
      <h3>Importar Arquivos</h3>
      <button [disabled]="isUploading" (click)="toggleWindow()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="!isUploading; else uploadingState">
      <div class="drop-zone" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" (click)="fileInput.click()">

        <mat-icon>cloud_upload</mat-icon>
        <p>Arraste arquivos aqui ou <span style="color: #1976d2; font-weight: 600; cursor: pointer;">clique para
            abrir</span></p>
        <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;">
      </div>

      <div class="file-info" *ngIf="selectedFile">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px;">description</mat-icon>
        <span class="name">{{ selectedFile.name }}</span>
        <mat-icon class="remove" (click)="clearSelection()">cancel</mat-icon>
      </div>

      <div class="footer-actions" *ngIf="selectedFile">
        <button mat-raised-button color="primary" (click)="uploadFile()" [disabled]="isUploading">
          Enviar Arquivo
        </button>
      </div>
    </div>

    <ng-template #uploadingState>
      <div class="loader-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Enviando arquivo...</p>
      </div>
    </ng-template>
  </div>

  <div *ngIf="showFloatingButton" class="fab-wrapper" [class.disabled]="isUploading" [class.minimized]="isMinimized" (click)="toggleWindow()">
    <button class="toggle-minimize" (click)="toggleMinimize($event)"
      [matTooltip]="isMinimized ? 'Maximizar botão' : 'Minimizar botão'"
      [matTooltipPosition]="isMinimized ? 'above' : 'left'">
      <mat-icon>{{ isMinimized ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}</mat-icon>
    </button>
    <span class="fab-label" *ngIf="!isMinimized">Importar arquivos</span>
    <button class="fab-button" [class.mini]="isMinimized">
      <mat-icon>{{ isWindowVisible ? 'expand_more' : 'upload_file' }}</mat-icon>
    </button>
  </div>
</div>